import { PcsNotifications } from '@app/pcs/shared/notifications/store/reducer/notifications';
import { Action } from '@ngrx/store';

export enum PcsNotificationsActionsTypes {
  FetchNotifications = '[PcsNotifications] Fetch Notifications',
  FetchNotificationsSuccess = '[PcsNotifications] Fetch Success',
  FetchNotificationsFailed = '[PcsNotifications] Fetch Failed',

  IncreaseNotSeenNewFeatureNumber = '[PcsNotifications] Increase Not Seen New Features',
  DecreaseNotSeenNewFeatureNumber = '[PcsNotifications] Decrease Not Seen New Features',
}

export class FetchPcsNotifications implements Action {
  readonly type = PcsNotificationsActionsTypes.FetchNotifications;
}

export class FetchPcsNotificationsSuccess implements Action {
  readonly type = PcsNotificationsActionsTypes.FetchNotificationsSuccess;

  constructor(public payload: PcsNotifications) {
  }
}

export class FetchPcsNotificationsFailed implements Action {
  readonly type = PcsNotificationsActionsTypes.FetchNotificationsFailed;

  constructor(public payload: Error) {
  }
}

export class IncreaseNotSeenNewFeaturesNumber implements Action {
  readonly type = PcsNotificationsActionsTypes.IncreaseNotSeenNewFeatureNumber;
}

export class DecreaseNotSeenNewFeaturesNumber implements Action {
  readonly type = PcsNotificationsActionsTypes.DecreaseNotSeenNewFeatureNumber;
}

export type PcsNotificationsActions = FetchPcsNotifications
| FetchPcsNotificationsSuccess
| FetchPcsNotificationsFailed
| IncreaseNotSeenNewFeaturesNumber
| DecreaseNotSeenNewFeaturesNumber;
